import {
  AcademiesStore,
} from './stores/academiesStore';
import {
  AppConfigurationStore,
} from './stores/appConfigurationStore';
import {
  AuthStore,
} from './stores/authStore';
import {
  BannerAdsStore,
} from './stores/bannerAdsStore';
import {
  BranchStore,
} from './stores/branchStore';
import {
  CalenderSepratorStore,
} from './stores/calenderSepratorStore';
import {
  CountryStore,
} from './stores/countryStore';
import {
  DeglawyContentStore,
} from './stores/deglawyContentStore';
import {
  DeglawyFeaturedStore,
} from './stores/deglawyFeaturedStore';
import {
  DeglawyPortalContentStore,
} from './stores/deglawyPortalContentStore';
import {
  DeglawyTrophyStore,
} from './stores/deglawyTrophyStore';
import {
  EventCategoryStore,
} from './stores/eventCategoryStore';
import {
  EventStore,
} from './stores/eventsStore';
import {
  FacilitiesCategoriesStore,
} from './stores/facilitiesCategoriesStore';
import {
  FacilityStore,
} from './stores/facilitiesStore';
import {
  FacilityGroupStore,
} from './stores/facilityGroupStore';
import {
  FeaturedArticlesStore,
} from './stores/featuredArticlesStore';
import {
  FeaturedOfferStore,
} from './stores/featuredOfferStore';
import {
  ForgotPasswordStore,
} from './stores/forgotPasswordStore';
import {
  GalleryStore,
} from './stores/galleryStore';
import {
  HomeStore,
} from './stores/homeStore';
import {
  MenuStore,
} from './stores/menuStore';
import {
  NewsAndAnnouncementStore,
} from './stores/newsAndAnnouncementStore';
import {
  NewsCategoryStore,
} from './stores/newsCategoryStore';
import {
  NotificationStore,
} from './stores/notificationStore';
import {
  ResetPassword,
} from './stores/resetPasswordStore';
import {
  RestaurantCategoryStore,
} from './stores/restaurantCategoryStore';
import {
  RestaurantStore,
} from './stores/restaurantStore';
import {
  StaticTextStore,
} from './stores/staticTextStore';
import {
  StatisticsStore,
} from './stores/statisticsStore';
import {
  FacilityAreaStore,
} from './stores/facilityAreaStore';
import {
  RolesStore,
} from './stores/rolesStore';
import {
  TransactionsStore,
} from './stores/transactionsStore';
import {
  CustomerServiceStore,
} from './stores/customerServiceStore';
import {
  GeneralAdsStore,
} from './stores/generalAdsStore';
import {
  OffersStore,
} from './stores/offersStore';
import {
  FacilityFormStore,
} from './stores/facilityFormStore';
import {
  GatesStore,
} from './stores/gatesStore';
import {
  WifiPackagesStore,
} from './stores/wifiPackagesStore';
import {
  CustomScreensStore,
} from './stores/customScreens';
import {
  SurveysStore,
} from './stores/surveysStore';
import { WheelFortuneStore } from './stores/wheelFortuneStore';
import { UserManagementStore } from './stores/userManagmentStore';
import {
  FacebookInfoStore,
} from './stores/facebookInfoStore';
import {
  ReleaseNotesStore,
} from './stores/releaseNotesStore';
import {
  BranchFeatureStore,
} from './stores/branchFeatureStore';
import {
  DeliveryRegionStore,
} from './stores/deliveryRegionStore';
import {
  CardsDeliveryStore,
} from './stores/cardsDeliveryStore';
import {NoAccessWheelStore} from "./stores/noAccessWheelStore";
import { UserDeletionRequestStore } from "./stores/userDeletionRequestStore";
import { LeadStore } from "./stores/leadStore";
import { LiveScoreStore } from "./stores/liveScoringStore";
import { AfconStore } from "./stores/afconStore";

export enum RequestStatus {
  IDLE = "idle",
  LOADING = "loading",
  SUCCESS = "success",
  FAILED = "failed",
}

const customScreenStore = new CustomScreensStore();

export const stores = {
  customScreenStore,
  authStore: new AuthStore(),
  branchStore: new BranchStore(),
  forgotPasswordStore: new ForgotPasswordStore(),
  resetPasswordStore: new ResetPassword(),
  newsAndAnnouncementStore: new NewsAndAnnouncementStore(),
  academiesStore: new AcademiesStore(),
  newsCategoryStore: new NewsCategoryStore(),
  restaurantStore: new RestaurantStore(),
  customerServiceStore: new CustomerServiceStore(),
  restaurantCategoryStore: new RestaurantCategoryStore(),
  generalAdsStore: new GeneralAdsStore(),
  menuStore: new MenuStore(),
  homeStore: new HomeStore(),
  bannerAdsStore: new BannerAdsStore(),
  featuredArticlesStore: new FeaturedArticlesStore(),
  facilitiesCategoriesStore: new FacilitiesCategoriesStore(),
  galleryStore: new GalleryStore(),
  staticTextStore: new StaticTextStore(),
  deglawyContentStore: new DeglawyContentStore(),
  deglawyFeaturedStore: new DeglawyFeaturedStore(),
  deglawyTrophyStore: new DeglawyTrophyStore(),
  notificationStore: new NotificationStore(),
  deglawyPortalContentStore: new DeglawyPortalContentStore(),
  facilityStore: new FacilityStore(),
  appConfigurationStore: new AppConfigurationStore(),
  statisticsStore: new StatisticsStore(),
  featuredOfferStore: new FeaturedOfferStore(),
  calenderSepratorStore: new CalenderSepratorStore(),
  eventCategoryStore: new EventCategoryStore(),
  eventStore: new EventStore(),
  gateStore: new GatesStore(),
  countryStore: new CountryStore(),
  facilityAreaStore: new FacilityAreaStore(),
  rolesStore: new RolesStore(),
  transactionsStore: new TransactionsStore(),
  offersStore: new OffersStore(),
  facilityFormStore: new FacilityFormStore(),
  wifiPackagesStore: new WifiPackagesStore(),
  customScreensStore: new CustomScreensStore(),
  surveysStore: new SurveysStore(),
  wheelFortuneStore: new WheelFortuneStore(),
  userManagementStore: new UserManagementStore(),
  facebookInfoStore: new FacebookInfoStore(),
  releaseNotesStore: new ReleaseNotesStore(),
  branchFeatureStore: new BranchFeatureStore(),
  facilityGroupStore: new FacilityGroupStore(),
  deliveryRegionStore: new DeliveryRegionStore(),
  cardsDeliveryStore: new CardsDeliveryStore(),
  noAccessStore: new NoAccessWheelStore(),
  userDeletionRequestStore: new UserDeletionRequestStore(),
  leadStore: new LeadStore(),
  liveScoringStore: new LiveScoreStore(),
  afconStore: new AfconStore(),
};
